import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import * as React from 'react';
import styled from 'styled-components';
// @mui
import { Container, Stack } from '@mui/material';
import { validateUser } from '../../api';
import config from '../../../config.json';
import Cadastros from './Cadastros';
import Entradas from './Entradas';
import Saidas from './Saidas';

const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;

const RadioButton = styled.input`
  margin-right: 10px;
`;

const RadioLabel = styled.label`
  font-size: 1em;
  color: rgb(0, 0, 0);
  font-weight: bold;
  line-height: 10px;
`;
// ----------------------------------------------------------------------

export default function Estoque() {
  const navigate = useNavigate();
  useEffect(() => {
    validateuser();
  }, []);
  const validateuser = async () => {
    const teste = await validateUser();
    if (!teste.ok) {
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {};
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente');
      return;
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario;
  };

  const [option, setOption] = useState('cadastros');

  const handleTypeChange2 = (e) => {
    setOption(e.target.value);
  };


  // ----------------------

  return (
    <>
      <Helmet>
        <title> Estoque </title>
      </Helmet>

      <Stack direction={'row'} gap={10} justifyContent={'center'}>
        <RadioButtonWrapper>
          <RadioButton
            type="radio"
            name="cadastros"
            value="cadastros"
            checked={option === 'cadastros'}
            onChange={handleTypeChange2}
          />
          <RadioLabel>Cadastros</RadioLabel>
        </RadioButtonWrapper>
        <RadioButtonWrapper>
          <RadioButton
            type="radio"
            name="entradas"
            value="entradas"
            checked={option === 'entradas'}
            onChange={handleTypeChange2}
          />
          <RadioLabel>Entradas</RadioLabel>
        </RadioButtonWrapper>
        <RadioButtonWrapper>
          <RadioButton
            type="radio"
            name="saidas"
            value="saidas"
            checked={option === 'saidas'}
            onChange={handleTypeChange2}
          />
          <RadioLabel>Saídas</RadioLabel>
        </RadioButtonWrapper>
      </Stack>

      <Container maxWidth="xl">
        {option === 'cadastros' && <Cadastros />}
        {option === 'entradas' && <Entradas />}
        {option === 'saidas' && <Saidas />}
      </Container>
    </>
  );
}
